import { Component, Input, OnInit } from '@angular/core';
import { ILabels } from 'libraries/interfaces/ILabels';
import { Yii } from 'libraries/interfaces/Yii';
import { ECouponStatus, ICoupon } from 'libraries/service/resources/booking/interfaces/IGetBookings';
import { EStatusPannel } from '../status-pannel/status-pannel.component';

@Component({
    selector: 'sectors-air-coupon-list',
    template: `
        <div class="status-container">
            <div class="status-infos">{{ coupon?.ticket?.number }}</div>
            <div>{{ wording.sector }} <span class="status-infos">{{ coupon?.index }}</span></div>
            <status-pannel [status]="couponStatus" [text]="coupon?.xState" [fixedWidth]="true"></status-pannel>
        </div>
    `,
    styles: [`
        .status-infos {
            font-weight: bold;
        }
    `]
})
export class SectorsAirCouponListComponent implements OnInit {
    @Input()
    public coupon: ICoupon;

    public wording: ILabels = {
        sector: Yii.t('wui-app-js', 'Coupon'),
    };

    public couponStatus: EStatusPannel;

    public ngOnInit(): void {
        this.getCouponStatus();
    }

    private getCouponStatus(): void {
        switch (this.coupon.xState) {
            case ECouponStatus.openForUse:
                this.couponStatus = EStatusPannel.success;
                break;

            case ECouponStatus.airportControl:
            case ECouponStatus.checkedIn:
            case ECouponStatus.boarded:
            case ECouponStatus.notified:
                this.couponStatus = EStatusPannel.inProgress;
                break;

            case ECouponStatus.irregularOperations:
            case ECouponStatus.suspend:
            case ECouponStatus.suspended:
            case ECouponStatus.unavailable:
                this.couponStatus = EStatusPannel.error;
                break;

            case ECouponStatus.used:
            case ECouponStatus.exchanged:
            case ECouponStatus.void:
            case ECouponStatus.refunded:
            case ECouponStatus.closed:
            case ECouponStatus.convertedToFIM:
            case ECouponStatus.printed:
            case ECouponStatus.unknown:
                this.couponStatus = EStatusPannel.used;
                break;

            default:
                break;
        }
    }
}
